import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName = 'user_statistics.xlsx') => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Format the data for Excel
    const formattedData = data.map(user => ({
        'Nom': user.name,
        'Nom d\'utilisateur': user.username,
        'Email': user.email,
        'Score des exercices': user.exerciseScore,
        'Défis gagnés': user.defisWon,
        'Total des leçons': user.totalLessons,
        'Temps passé (minutes)': Math.round(user.timeSpent / 60),
        'Score total': user.score
    }));

    // Create a worksheet from the formatted data
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Statistiques des utilisateurs');

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, fileName);
}; 